import { render, staticRenderFns } from "./PriceHistoryForProduct.vue?vue&type=template&id=34bd74ba&"
import script from "./PriceHistoryForProduct.vue?vue&type=script&lang=js&"
export * from "./PriceHistoryForProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports